<template>
    <base-dialog :value="dialog" :width="460" :title="$t('entrance.remember_password_title')" @input="onInput"
        @close="hide">
        <v-alert v-if="passwordRecoverySuccess" color="success" dark border="left" icon="mdi-check-circle-outline"
            class="mb-0">
            {{ $t('entrance.email_request_send') }}
        </v-alert>
        <v-form v-else v-model="valid">
            <kimsa-text-field ref="emailField" :label="$t('entrance.email')" :placeholder="$t('entrance.email_placeholder')"
                :rules="emailRules" @change="email = $event" :inputMode="'email'"
                :readonly="loadingPasswordRecovery" :loading="loadingPasswordRecovery" />
        </v-form>

        <template v-if="!passwordRecoverySuccess" v-slot:footer>
            <v-btn class="footer-btn" depressed block :loading="loadingPasswordRecovery" @click="passwordRecovery">
                {{ $t('common.continue') }}
            </v-btn>
        </template>
    </base-dialog>
</template>

<script>

import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import BaseDialog from "@/components/common/BaseDialog";

import { sendPasswordReset } from '@/utils/PasswordReset'

export default {
    components: { KimsaTextField, BaseDialog },
    data(vm = this) {
        return {
            dialog: false,
            valid: false,
            loadingPasswordRecovery: false,
            passwordRecoverySuccess: false,
            email: '',
            emailRules: [
                v => !!v || vm.$t('rules.required'),
                v => new RegExp(/.+@.+\..+/).test(v) || vm.$t('rules.invalid_email')
            ],
        }
    },
    methods: {
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            this.dialog = false
        },
        onInput(val) {
            if (!val) this.hide()
        },
        reset() {
            const vm = this
            if (vm.$refs.emailField) vm.$refs.emailField.reset()
            vm.valid = false
            vm.loadingPasswordRecovery = false
            vm.passwordRecoverySuccess = false
            vm.email = ''
        },
        async passwordRecovery() {
            const vm = this
            if (!vm.valid) return vm.toast(vm.$t('rules.invalid_email'), 'error')
            if (vm.loadingPasswordRecovery === true) return
            vm.loadingPasswordRecovery = true
            try {
                await sendPasswordReset(vm.email, vm.$i18n.locale)
                vm.loadingPasswordRecovery = false
                vm.passwordRecoverySuccess = true
            } catch (error) {
                console.log('error', error)
                vm.loadingPasswordRecovery = false
                vm.toast(vm.$t('entrance.error_sending_email'), 'error')
            }
        }
    },
    watch: {
        passwordRecoverySuccess(val) {
            if (val) {
                setTimeout(() => {
                    this.hide()
                }, 3000)
            }
        },
        dialog(newVal) {
            if (!newVal) this.reset()
        }
    }
}
</script>

<style scoped>
.footer-btn.v-btn {
    height: 52px !important;
    border-radius: 0 !important;
    text-transform: none;
    letter-spacing: normal;
    font-weight: 700;
    box-shadow: none !important;
    background: var(--v-primary-base) !important;
    color: #0C0E12 !important;
}
</style>
